import React, { Component } from 'react'
import { Tooltip, OverlayTrigger  } from 'react-bootstrap'

import AppTools from 'utils/app/appTools'
import APPURL from 'utils/app/urls'


const MAP_DIMENSIONS = [
	{
		id: 0,
		x: 150, y: 50,
		w: 150, h: 50,
		r: 10
	},
	{
		id: 1,
		x: 150,  y: 125,
		w: 150,  h: 50,
		r: 10
	},
	{
		id: 2,
		x: 350,  y: 25,
		w: 75,  h: 175,
		r: 10
	},
	{
		id: 3,
		x: 25,  y: 25,
		w: 75,  h: 175,
		r: 10
	}
];

class MiniMap extends Component {

	componentDidMount() {
		// console.log(this.props);
	}

	componentDidUpdate() {
	}

	componentWillUnmount() {
	}

	renderIfAllOK() {
		// const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : '';
		let actualURL = this.props.history.location.pathname;

		const defaultStyle = {
			fill: "rgb(177, 196, 220)",
			stroke: "rgb(216, 216, 216)"
		};
		const tooltips = {};
		tooltips["dim_0"] = <Tooltip id="tooltip">Dimension 0</Tooltip>;
		tooltips["dim_1"] = <Tooltip id="tooltip">Dimension 1</Tooltip>;
		tooltips["dim_2"] = <Tooltip id="tooltip">Dimension 2</Tooltip>;
		tooltips["dim_3"] = <Tooltip id="tooltip">Dimension 3</Tooltip>;

		let dimensionRects = [];
		MAP_DIMENSIONS.forEach( (d, index) => {
			let title = AppTools.getDimensionTitle( d.id );
			let tooltip = <Tooltip id="tooltip">{title}</Tooltip>;
			let dimensionLink = null;
			if ( this.props.dimensionLinks !== undefined ) {
				dimensionLink = this.props.dimensionLinks[d.id];
			} else {
				dimensionLink = APPURL.getLevelDetailLink({ url: actualURL, level: d.id });
			}
			
			let className = `obs-dimension-${d.id}`;
			if ((this.props.dimension !== undefined) && (d.id !== Number(this.props.dimension))) {
				className += ' disabled';
			}
			let dimensionRect = <React.Fragment key={index}>
				<rect width={d.w} height={d.h} className={className} rx={d.r} ry={d.r} x={d.x} y={d.y}></rect>
			</React.Fragment>;

			if ( dimensionLink !== null ) {
				dimensionRect = <OverlayTrigger overlay={tooltip} placement="top" key={`minimap-${index}`}>
				<a href={dimensionLink}>{dimensionRect}</a>
			</OverlayTrigger>;
			}
			dimensionRects.push( dimensionRect );
		} );

		return <React.Fragment>
			<div className="framework-map">
				<svg version="1.1" viewBox="20 20 410 185">
					<rect width="200" height="175" style={defaultStyle} rx="10" ry="10" x="125" y="25"></rect>
					{dimensionRects}
					{/* <OverlayTrigger overlay={tooltips.dim_0} placement="top">
						<a>
							<rect width="75" height="175" className="obs-dimension-2" rx="4" ry="4" x="25" y="25"></rect>
						</a>
					</OverlayTrigger>
					<OverlayTrigger overlay={tooltips.dim_1} placement="top">
						<a>
							<rect width="75" height="175" className="obs-dimension-3" rx="4" ry="4" x="350" y="25"></rect>
						</a>
					</OverlayTrigger>
					<OverlayTrigger overlay={tooltips.dim_2} placement="top">
						<a>					
							<rect width="150" height="50" className="obs-dimension-0" rx="4" ry="4" x="150" y="50"></rect>
						</a>
					</OverlayTrigger>
					<OverlayTrigger overlay={tooltips.dim_3} placement="top">
						<a>
							<rect width="150" height="50" className="obs-dimension-1" rx="4" ry="4" x="150" y="125"></rect>
						</a>
					</OverlayTrigger> */}
				</svg>
			</div>
		</React.Fragment>;
	}

	render() {
		return this.renderIfAllOK();
	}
}

export default MiniMap;



// WEBPACK FOOTER //
// ./src/modules/Content/MiniMap/MiniMap.jsx